module.exports = __webpack_public_path__ + "static/img/commitment-3_light.46225d61.png";